import Lottie from 'lottie-react';
import animationContent from '../../../data/animations/organizationCreationAnimation.json';
import { useBeforeUnloadListener } from '../../../hooks/windowEvents/useBeforeUnloadListener';
import { useTranslation } from '../../../hooks/useTranslation';

const TransferOwnershipLoader = () => {
    useBeforeUnloadListener(true);
    const { t } = useTranslation();

    return (
        <div className="transfer-ownership-loader">
            <div className="organization-loader">
                <h2>{t('settings.loaderTitle')}</h2>
                <Lottie className="organization-loader__animation" animationData={animationContent} loop={true} />
                <p className="organization-loader__subtitle">{t('settings.loaderDescription')}</p>
            </div>
        </div>
    );
};

export default TransferOwnershipLoader;
